import { useKiosk } from '../lib/session';

/** 設計稿列出的四段條文。標題為業主給定，內文尚未提供。 */
const SECTIONS = ['checkin', 'change', 'cruise', 'water'] as const;

interface PurchaseNoticeModalProps {
  onClose: () => void;
}

/**
 * 購票須知彈窗 — 頁尾「購票須知」開啟。
 *
 * ## 目前只有骨架
 *
 * 設計稿把須知分成報到提醒／航程異動／遊艇航程／水上設施四段，但**條文內文
 * 業主尚未提供**（設計稿上那幾行是版面示意）。這裡照四段結構先把彈窗做出來，
 * 內文以 i18n key 佔位並明白標示待補——購票須知是會被旅客當成契約依據的東西，
 * 由開發端代擬條文再上機台，比空著更危險。
 *
 * 設計稿另要求「訂票前自動彈出」，那牽涉購票動線，不在識別層這一輪。
 */
export function PurchaseNoticeModal({ onClose }: PurchaseNoticeModalProps): JSX.Element {
  const { t } = useKiosk();

  return (
    <div
      className="k-modal__backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={t('footer.notice')}
    >
      <div className="k-modal">
        <h2 className="k-modal__title">{t('notice.title')}</h2>

        <div className="k-modal__body">
          {SECTIONS.map((key) => (
            <section key={key} className="k-notice__section">
              <h3 className="k-notice__heading">{t(`notice.${key}.title`)}</h3>
              <p className="k-notice__text k-text--dim">{t('notice.pending')}</p>
            </section>
          ))}
        </div>

        <button type="button" className="k-btn k-btn--primary k-btn--block" onClick={onClose}>
          {t('notice.close')}
        </button>
      </div>
    </div>
  );
}
